// ----------------------------------------------------------------------
// <copyright file="Izenda.InsertTablePopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
//
/**
 * Insert Table Popup component
 */
!(function() {
  var React = require('react');
  var { times } = require('lodash/fp');
  var Popover = require('share/components/controls/Izenda.Popover').Popover;
  var DEFAULT_ROW_NUMBER = 10;

  var InsertTablePopup = React.createClass({
    propTypes: {
      onChange: React.PropTypes.func
    },

    getInitialState: function() {
      return {
        isOpen: false
      };
    },

    // Return data for update data.
    getValue: function() {
      var state = this.state;
      return state;
    },

    selectGrid: function(tx, ty) {
      var table = this.refs.gridTable;
      var x, y, focusCell, cell, active;
      table.nextSibling.innerHTML = tx + 1 + ' x ' + (ty + 1);

      for (y = 0; y < DEFAULT_ROW_NUMBER; y++) {
        for (x = 0; x < DEFAULT_ROW_NUMBER; x++) {
          cell = table.rows[y].childNodes[x].firstChild;
          active = x <= tx && y <= ty;
          cell.className = active ? 'active' : '';

          if (active) {
            focusCell = cell;
          }
        }
      }

      return focusCell && focusCell.parentNode;
    },

    handleSelectCell: function(e) {
      var target = e.target,
        x,
        y;
      if (target.tagName.toUpperCase() === 'A') {
        x = parseInt(target.getAttribute('data-x'), DEFAULT_ROW_NUMBER);
        y = parseInt(target.getAttribute('data-y'), DEFAULT_ROW_NUMBER);

        if (x !== this.lastX || y !== this.lastY) {
          this.selectGrid(x, y, e.control);
          this.lastX = x;
          this.lastY = y;
        }
      }
    },

    handleInsertTable: function(e) {
      if (e.target.tagName.toUpperCase() === 'A') {
        e.preventDefault();
        e.stopPropagation();
        this.props.editorControl.insertTable(this.lastX + 1, this.lastY + 1);
        this.setState({ isOpen: false });
      }
    },

    generateTableGrid: function() {
      var arrayNumber = times(String, DEFAULT_ROW_NUMBER);
      var columns = function(y) {
        return arrayNumber.map(function(x) {
          return (
            <td className='grid-cell' key={x + y}>
              <a data-x={x} data-y={y} />
            </td>
          );
        });
      };
      var rows = arrayNumber.map(function(y) {
        return <tr key={y}>{columns(y)}</tr>;
      });

      return (
        <table
          className='grid-border'
          ref='gridTable'
          onMouseMove={this.handleSelectCell}
          onClick={this.handleInsertTable}
        >
          <tbody>{rows}</tbody>
        </table>
      );
    },

    renderPopup: function() {
      return (
        <Popover visible={this.state.isOpen} positionLeft={-75} positionTop={15} onHide={this.onHidePopup} rootClose>
          {this.generateTableGrid()}
          <div className='text-center'>1 x 1</div>
        </Popover>
      );
    },

    handleClickButton: function() {
      this.setState({
        isOpen: true
      });
    },

    render: function() {
      var props = this.props;
      var data = props.data;

      return (
        <span className='u-posRelative insert-table'>
          <a className='btn' title={data.title} onClick={this.handleClickButton}>
            <i className={data.className} />
          </a>

          {/* Popup setting table*/}
          {this.renderPopup()}
        </span>
      );
    }
  });
  module.exports = InsertTablePopup;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.InsertTablePopup.jsx